// @ts-ignore
import * as React from "react";
import styled from "styled-components";

import {
  theme,
  rgba
} from "src/library/utils";

import Grid from "../Hedron";
import { IFormRadio } from ".";
import FieldError from "./FieldError";
import Label from "./Label";

const hexToRgba = rgba(theme.colors.primaryDark, 1);
const radioDot = `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 200 200' fill='${hexToRgba}' stroke='none'><path d='M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0' /></svg>`;

export const RadioStyled = styled.input.attrs({ type: "radio" })`
  display: block;
  appearance: none;
  margin: 2px;
  width: 25px;
  height: 25px;
  background-color: ${({ theme }) => theme.colors.white};
  background-image: url("${radioDot}");
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 0% auto;
  border-radius: 100%;
  border: 2px solid ${({ theme }) => theme.colors.primaryDark};
  box-sizing: border-box;
  outline: none;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    opacity: 0.5;

    &:hover {
      cursor: not-allowed;
    }
  }

  &:checked {
    background-size: 100% auto;
  }
`;

export const RadioLabel = styled(Label)`
  display: flex;
  align-items: center;

  span {
    padding-left: 10px;
    line-height: 30px;
  }
`;

const Radio: React.ReactFCWithChildren<IFormRadio> = props => {
  return (
    <>
      <Grid.Box>
        <Label
          for={props.name}
          label={props.label}
          required={props.validation?._exclusive?.required}
        />
      </Grid.Box>

      <Grid.Box>
        {props.options.map((opt, index) => (
          <Grid.Bounds
            key={`${props.name}-${index}`}
            valign="top"
            direction="horizontal"
            style={{ position: "relative" }}
          >
            <Grid.Box>
              <RadioLabel
                className="radio-label"
                for={`${props.name}-${index}`}
                label={opt.text}
              >
                <RadioStyled
                  disabled={props.disabled}
                  onChange={props.handleChange}
                  name={props.name}
                  id={`${props.name}-${index}`}
                  defaultChecked={opt.checked}
                  value={opt.value}
                />
              </RadioLabel>
            </Grid.Box>
          </Grid.Bounds>
        ))}
      </Grid.Box>

      {props.error && (
        <Grid.Box>
          <FieldError>
            {props.error}
          </FieldError>
        </Grid.Box>
      )}
    </>
  );
};

export default Radio;
